<mat-spinner *ngIf="(loading$ | async); else showContent" [diameter]="80" [strokeWidth]="3"></mat-spinner>

<ng-template #showContent>
  <div [ngClass]="categoryId ? 'appContainer1 centerVertical' : 'appContainer1'">


    <div class="row rowcategoryList" *ngIf="categories$ | async as categories" (window:resize)="onResize($event)">

      <div *ngIf='(session.isLoggedIn$ | async) && baselang == translationService.getCurrentLanguage()'
           style="margin-bottom: 20px;">
        <button (click)="openCategoryDialogDialog()" mat-raised-button color="secondary" style="margin-right:10px;">
          {{ 'Add category' | translate }}
        </button>
      </div>

      <div *ngIf="events.length > 0">
        <div class="event-block-fixed">
        <div class="event-block">
          <h1 class="event-min-title">⚠ {{ 'Events / Infos' | translate }}</h1>
          <a class="event-item-min" routerLink="/infos">
            <div>
              <h3>{{ events[0].title }}</h3>
              <p class="date">{{ formatEventDate(events[0].date) }}</p>
            </div>
          </a>
        </div>
        </div>
      </div>

      <h1 class="home-menu-title">{{ 'Our menu' | translate }}</h1>
      <ng-container *ngFor="let category of categories">
        <div class="{{ category.isSunday ? 'col-12' : 'col-6 col-sm-4 col-md-4' }}  categoryList">
          <a routerLink="/categories/{{category.id.toString()}}">


            <img
              [alt]="category.name"
              [src]="category.image300Url"
              [lazyLoad]="category.image300Url"
              *ngIf="category.image300Url && !category.isSunday"
              [debug]="false"
              [offset]="100"
              src="assets/images/svg-loaders/tail-spin.svg"
            />

            <img
              [alt]="category.name"
              [src]="category.largeImage"
              [lazyLoad]="category.largeImage"
              *ngIf="category.largeImage && category.isSunday"
              [debug]="false"
              [offset]="100"
              src="assets/images/svg-loaders/tail-spin.svg"
            />
            <div class="categoryName">
              {{ category.name }}
            </div>

            <div *ngIf="category.isSunday" class="sep"></div>
          </a>
        </div>
      </ng-container>

    </div>

    <app-app-copyright></app-app-copyright>


  </div>

</ng-template>
